<template>
  <div class="row mx-0 px-3 py-4 gap-md-4 d-flex">
    <div class="row col-12 col-md-6 pe-0 mb-3 mb-md-0 flex-column">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">氏名（漢字）</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="col-12">
        <div class="row p-0">
          <div class="col-6 pe-0">
            <Field
              v-slot="{ field, errors }"
              v-model="baseInformationStore.last_name"
              name="last_name"
            >
              <input
                class="input-primary form-control size-14 bg-silver-primary p-0d8"
                :class="{ 'is-invalid': !!errors.length }"
                placeholder="姓"
                v-bind="field"
              />
              <ErrorMessage name="last_name" class="invalid-feedback" />
            </Field>
          </div>
          <div class="col-6 pe-0">
            <Field
              v-slot="{ field, errors }"
              v-model="baseInformationStore.first_name"
              name="first_name"
            >
              <input
                class="input-primary form-control size-14 bg-silver-primary p-0d8"
                placeholder="名"
                :class="{ 'is-invalid': !!errors.length }"
                v-bind="field"
              />
              <ErrorMessage name="first_name" class="invalid-feedback" />
            </Field>
          </div>
        </div>
      </div>
    </div>
    <div class="row col-12 col-md-6 pe-0 flex-column">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">氏名（カナ）</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="col-12">
        <div class="row p-0">
          <div class="col-6 pe-0">
            <Field
              v-slot="{ field, errors }"
              v-model="baseInformationStore.last_name_kana"
              name="last_name_kana"
            >
              <input
                class="input-primary form-control size-14 bg-silver-primary p-0d8"
                placeholder="セイ"
                :class="{ 'is-invalid': !!errors.length }"
                v-bind="field"
              />
              <ErrorMessage name="last_name_kana" class="invalid-feedback" />
            </Field>
          </div>
          <div class="col-6 pe-0">
            <Field
              v-slot="{ field, errors }"
              v-model="baseInformationStore.first_name_kana"
              name="first_name_kana"
            >
              <input
                class="input-primary form-control col-6 size-14 bg-silver-primary p-0d8"
                placeholder="メイ"
                :class="{ 'is-invalid': !!errors.length }"
                v-bind="field"
              />
              <ErrorMessage name="first_name_kana" class="invalid-feedback" />
            </Field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ErrorMessage, Field } from 'vee-validate';
import { useBaseInformationStore } from '@/stores/resume-candidate/BasicInformation.store';
const baseInformationStore = useBaseInformationStore();
</script>
